"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFidesCookie = exports.default = exports.FIDES_COOKIE = void 0;
var _utils = _interopRequireDefault(require("../../utils"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var FIDES_COOKIE = exports.FIDES_COOKIE = 'fides_consent';

/**
 * Reads and parses the Fides cookie if it exists
 *
 * @returns The parsed Fides cookie data, or an empty object if the cookie does not exist or is invalid
 */
var getFidesCookie = exports.getFidesCookie = function getFidesCookie() {
  var cookieValue = (0, _utils.default)(FIDES_COOKIE, '');
  if (!cookieValue) {
    return {};
  }
  try {
    return JSON.parse(decodeURIComponent(cookieValue));
  } catch (error) {
    return {};
  }
};

/**
 * Checks for functional cookie consent via the Fides cookie
 *
 * @returns Whether functional cookies are blocked per the Fides cookie
 */
var blockedByFidesCookie = function blockedByFidesCookie() {
  var _cookieData$consent;
  var cookieData = getFidesCookie();
  return !(cookieData !== null && cookieData !== void 0 && (_cookieData$consent = cookieData.consent) !== null && _cookieData$consent !== void 0 && _cookieData$consent.functional);
};

/**
 * Checks for cookie consent via the Fides banner, falling back to the
 * Fides cookie if the banner hasn't been initialized yet.
 *
 * @returns Whether functional cookies are blocked by Ethyca Fides
 */
var blockedByFides = function blockedByFides() {
  var win = window;
  // even though the Fides API should be backed by cookie data, defer to that value
  // if the API is present
  if (win.Fides) {
    var _win$Fides$consent;
    return !((_win$Fides$consent = win.Fides.consent) !== null && _win$Fides$consent !== void 0 && _win$Fides$consent.functional);
  }

  // fallback to attempting to read the cookie. here, the lack of a cookie will
  // result in assumed non-consent
  return blockedByFidesCookie();
};

/**
 * Returns whether or not functional cookies have been consented to via the cookie
 * consent banner, allowing for multiple cookie consent providers.
 *
 * @param overrideCookieConsent Allow cookie consent to be overridden by the consuming application.
 *                              This is largely for internal tools.
 * @returns
 */
var blockedByCookieConsent = function blockedByCookieConsent() {
  var overrideCookieConsent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  if (overrideCookieConsent) {
    return false;
  }
  return blockedByFides();
};
var _default = exports.default = blockedByCookieConsent;
//# sourceMappingURL=consent.js.map